import { LocationHook } from "preact-iso";
import { AreaFilters, areaFiltersDefault, areaFiltersEmpty, mergeDefaults } from "./area-filters";
import { UrlState } from "@/elements-react/product-area/url-state.ts";

export const parseLocation = (location: LocationHook): AreaFilters => {
    const filters = structuredClone(areaFiltersEmpty);
    const search = new URLSearchParams(location.query);
    const url = new UrlState();

    filters.sort = url.readParam(search, "filters")?.sort ?? null;
    filters.page = url.readIntegerParam(search, "page") ?? null;
    filters.search = url.readStringParam(search, "q") ?? null;

    const filterData = url.readParam(search, "filters");

    if (filterData) {
        filters.brands = filterData.brands || [];
        filters.categories = filterData.categories || [];
        filters.priceMin = filterData.priceMin ?? null;
        filters.priceMax = filterData.priceMax ?? null;
    }

    return filters;
};

export const createLocationParams = (filters: AreaFilters): { search: URLSearchParams } => {
    const search = new URLSearchParams();
    const url = new UrlState();
    const pageEquals = filters.page === areaFiltersDefault.page;
    const filtersEquals = filters.sort === areaFiltersDefault.sort &&
        filters.brands.length === 0 &&
        filters.categories.length === 0 &&
        filters.priceMin === areaFiltersDefault.priceMin &&
        filters.priceMax === areaFiltersDefault.priceMax;
    const searchEquals = filters.search === areaFiltersDefault.search;

    if (!filtersEquals) {
        url.writeParam(search, "filters", {
            sort: filters.sort,
            brands: filters.brands,
            categories: filters.categories,
            priceMin: filters.priceMin,
            priceMax: filters.priceMax,
        });
    }

    if (!pageEquals) {
        url.writeIntegerParam(search, "page", filters.page!);
    }

    if (!searchEquals) {
        url.writeStringParam(search, "q", filters.search!);
    }

    return { search };
};

export const getLocationValues = (location: LocationHook): AreaFilters => {
    const origin = parseLocation(location);
    const values = mergeDefaults(origin);

    return values;
};